var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"boddy",staticClass:"boddy"},[_c('Header',{attrs:{"isScrolled":_vm.isScrolled}}),(_vm.isonhow)?_c('img',{staticClass:"imgoneru",attrs:{"src":_vm.imageUrlone,"alt":""}}):_vm._e(),_vm._m(0),_c('Bottom')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"map"}})])
}]

export { render, staticRenderFns }